import { PARTICIPANT_PARAM_MAP, ParticipantEnum } from '@/constants/common';

export const getParticipantByParam = (
  participantParam?: string
): ParticipantEnum | undefined => {
  if (!participantParam) return;
  return PARTICIPANT_PARAM_MAP[participantParam.trim().toLowerCase()];
};

export const getParticipantByPathname = (
  pathname?: string | null
): ParticipantEnum | undefined => {
  if (!pathname) return;
  const [first, second] = pathname.split('/').filter(Boolean);
  return getParticipantByParam(first === 'search' ? second : first);
};
